// Second admin route — exists in F4 only to verify that nav auto-derivation
// groups multiple routes correctly under the same `nav.group`. Real
// admin reports surface lands later (not in the bootstrap).

import { TablePage } from '@podium/platform/layouts'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/reports')({
  component: AdminReports,
  staticData: {
    nav: { label: 'Reports', order: 20, group: 'Admin' },
    breadcrumb: 'Reports',
  },
})

function AdminReports() {
  return (
    <TablePage title="Admin reports">
      <div className="rounded border border-dashed p-8 text-center text-sm text-muted-foreground">
        Placeholder.
      </div>
    </TablePage>
  )
}
